/**
 * @documental
 * @export Option
 * @name
 * MultiSelectDropdown.Option
 */

import { FC, ReactNode } from "react";
import { TagType } from "capitalrx-components-2.0/lib/general";

/**
 * The `Option` component properties.
 */
export interface OptionProps {
  /**
   * The optional plain text label used for screen readers and search.
   * If not specified the content is used instead.
   * If specified and no content is specified the label is used instead.
   */
  readonly label?: string;

  /**
   * The type of the tag to display for the option when selected. If not specified defaults to `"info"`.
   */
  readonly type?: TagType;

  /**
   * Indicates whether to invert the tag color.
   */
  readonly inverted?: boolean;

  /**
   * The option value.
   */
  readonly value: string | number;

  /**
   * The options to display.
   */
  readonly children?: ReactNode;
}

/**
 * A single option for the `Dropdown` component.
 */
export const Option: FC<OptionProps> = () => {
  return null;
};
